import { Link } from '@mui/material'
import VeroLoginForm from 'components/Providers/Vero/LoginForm'
import { useThemeStore } from 'contexts/ThemeStore'
import React, { useEffect } from 'react'
import { useTheme } from 'styled-components'
import { Content, Footer, FormContent, Header, HeaderImg, Img, Login } from './styled'

function VeroAuth() {
  const styleTheme = useTheme()
  const { switchTheme } = useThemeStore()

  useEffect(() => {
    switchTheme('verofamilia', 'light')
  }, [])

  return (
    <Content>
      <Login>
        <Header>
          <HeaderImg>
            <Img src={styleTheme.imgForm} alt='Vero by guigo' />
          </HeaderImg>
        </Header>
        <FormContent>
          <VeroLoginForm />
        </FormContent>
        <Footer>
          <Link href='https://verointernet.com.br/minhavero/#/login' target='_blank' color={styleTheme.colors.primary.main}>
            Esqueceu a senha?
          </Link>
        </Footer>
      </Login>
    </Content>
  )
}

export default VeroAuth
